export const SelectRoleField = {
  extends: 'SelectField',
  Select: {
    name: 'role',
    id: 'role',
    childrenAs: 'props',
    children: () => [
      {
        value: 'guest',
        text: '{{ members.role.guest | polyglot }}'
      },
      {
        value: 'editor',
        text: '{{ members.role.editor | polyglot }}'
      },
      {
        value: 'admin',
        text: '{{ members.role.admin | polyglot }}'
      }
    ],
    childProps: {
      tag: 'option',
      attr: {
        selected: (el, s) => {
          const userRole = s.role || -1
          const optionValue = el.value
          return userRole === optionValue
        }
      }
    }
  }
}
